import { kitMessages, useTranslate } from '@classgo/app-kit';

import { webMessages } from './messages/es-co';

/**
 * The school app's catalogue: the kit's strings plus its own.
 */
export const messages = { ...kitMessages, ...webMessages } as const;

/**
 * The translate function typed by the school app's keys.
 *
 * @returns `t(key, params)`.
 */
export const useT = () => useTranslate<keyof typeof messages>();
